// LifecycleBadgeCard — custom_render statcard body for the donor
// detail's "Lifecycle" stat slot.
//
// CHG-1665 / ITER-3774 (Wave 1 / Tier 1 — DonorDetail port).
//
// Consumed via the override-block:statcard-lifecycle-badge in
// generated/screens/donor-detail.ts. The override-block's `render:`
// is replaced with `createElement(LifecycleBadgeCard, { donor: r })`.
//
// Why a separate component (vs an inline `render: createElement(...)`):
// the lifecycle chip + descriptive blurb is rich enough to warrant
// its own file — keeps the generated override-block body to a single
// createElement call.

import { StageChip } from "../composition/StageChip";
import type { Donor } from "../../api/types";

// Short blurb per stage so the card carries operator-facing
// context, not just the chip token. Mirrors v1 DonorDetail's
// LifecycleStepper subtext without pulling the full primitive.
const STAGE_BLURB: Record<Donor["lifecycle_stage"], string> = {
  prospect: "No gift yet — outreach candidate.",
  first_time: "Single gift on record — onboarding window.",
  active: "Recently engaged.",
  at_risk: "Engagement slipping — re-cultivate.",
  lapsed: "No recent activity.",
  reactivated: "Returned after a lapse.",
  recurring: "On an active recurring schedule.",
  vip: "Top-tier giver.",
};

export function LifecycleBadgeCard({ donor }: { donor: Donor }) {
  return (
    <div
      data-testid="lifecycle-badge-card"
      style={{ display: "flex", flexDirection: "column", gap: 6 }}
    >
      <StageChip
        stage_id={donor.lifecycle_stage}
        entity="donor"
        size="md"
      />
      <span
        style={{
          fontSize: 11,
          color: "var(--color-text-muted)",
          lineHeight: 1.4,
        }}
      >
        {STAGE_BLURB[donor.lifecycle_stage] ?? "—"}
      </span>
    </div>
  );
}
